import { render, staticRenderFns } from "./HasilLabSampel.vue?vue&type=template&id=46d82c1c&scoped=true&"
import script from "./HasilLabSampel.vue?vue&type=script&lang=ts&"
export * from "./HasilLabSampel.vue?vue&type=script&lang=ts&"
import style0 from "./HasilLabSampel.vue?vue&type=style&index=0&id=46d82c1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d82c1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
